import React from "react";

import { ContainerBg } from "../../useGeneralStyles";
import WithdrawalsRequestList from "../FundedTrader/components/WithdrawalsRequestList";
import { useAdminProviderDataContext } from "../../context";

const Withdrawals = (): React.ReactElement | null => {
  const {
    user: { allowed_features },
  } = useAdminProviderDataContext();

  if (!allowed_features.access_withdrawals) {
    return null;
  }

  return (
    <ContainerBg>
      <WithdrawalsRequestList />
    </ContainerBg>
  );
};

export default Withdrawals;
